import Constants from '@/Constants';
import { Reducer } from 'redux';
import { PURGE } from 'redux-persist';
import { Favorite, FavoriteState, FavoriteTypes } from './types';

const INITIAL_STATE: FavoriteState = {
    data: {} as Favorite,
    loading: false,
    hasError: false,
    favoriteList: [] as Favorite[],
    success: false,
};

const reducer: Reducer<FavoriteState> = (state: FavoriteState = INITIAL_STATE, action) => {
    switch (action.type) {
        case PURGE:
            return { ...INITIAL_STATE };
        case FavoriteTypes.GET_FAVORITE_LIST_CLEAR:
            return { ...INITIAL_STATE };
        case FavoriteTypes.GET_FAVORITE_LIST_REQUEST:
            return { ...state, loading: true };
        case FavoriteTypes.GET_FAVORITE_LIST_SUCCESS:
            return { ...state, loading: false, favoriteList: action.payload };
        case FavoriteTypes.REMOVE_COURSE_FAVORITE_REQUEST:
            const favCourseToRemove: Favorite = state.favoriteList.find(
                (fav: Favorite) => fav.contentType === Constants.entityTypes.COURSE && fav.contentId === action.payload.contentId,
            ) as Favorite;
            const favCourseToRemoveIndex: number = state.favoriteList.indexOf(favCourseToRemove);
            const favcourseStateResult: FavoriteState = { ...state };
            favcourseStateResult.favoriteList.splice(favCourseToRemoveIndex, 1);
            favcourseStateResult.loading = true;
            return favcourseStateResult;
        case FavoriteTypes.REMOVE_CONTENT_FAVORITE_REQUEST:
            const favContentToRemove: Favorite = state.favoriteList.find(
                (fav: Favorite) => fav.contentType === Constants.entityTypes.CONTENT && fav.contentId === action.payload.contentId,
            ) as Favorite;
            const favContentToRemoveIndex: number = state.favoriteList.indexOf(favContentToRemove);
            const favContentStateResult: FavoriteState = { ...state };
            favContentStateResult.favoriteList.splice(favContentToRemoveIndex, 1);
            favContentStateResult.loading = true;
            return favContentStateResult;
        case FavoriteTypes.REMOVE_CATEGORY_FAVORITE_REQUEST:
            const favCategoryToRemove: Favorite = state.favoriteList.find(
                (fav: Favorite) => fav.contentType === Constants.entityTypes.CATEGORY && fav.contentId === action.payload.contentId,
            ) as Favorite;
            const favCategoryToRemoveIndex: number = state.favoriteList.indexOf(favCategoryToRemove);
            const favCategoryStateResult: FavoriteState = { ...state };
            favCategoryStateResult.favoriteList.splice(favCategoryToRemoveIndex, 1);
            favCategoryStateResult.loading = true;
            return favCategoryStateResult;
        case FavoriteTypes.REMOVE_PROGRAM_FAVORITE_REQUEST:
            const favProgramToRemove: Favorite = state.favoriteList.find(
                (fav: Favorite) => fav.contentType === Constants.entityTypes.PROGRAM && fav.contentId === action.payload.contentId,
            ) as Favorite;
            const favProgramToRemoveIndex: number = state.favoriteList.indexOf(favProgramToRemove);
            const favProgramStateResult: FavoriteState = { ...state };
            favProgramStateResult.favoriteList.splice(favProgramToRemoveIndex, 1);
            favProgramStateResult.loading = true;
            return favProgramStateResult;
        case FavoriteTypes.SET_COURSE_FAVORITE_SUCCESS:
        case FavoriteTypes.SET_CONTENT_FAVORITE_SUCCESS:
        case FavoriteTypes.SET_CATEGORY_FAVORITE_SUCCESS:
        case FavoriteTypes.SET_PROGRAM_FAVORITE_SUCCESS:
            return { ...state, loading: false, data: { ...action.payload } };
        case FavoriteTypes.GET_FAVORITE_LIST_FAILURE:
        case FavoriteTypes.SET_COURSE_FAVORITE_FAILURE:
        case FavoriteTypes.SET_CONTENT_FAVORITE_FAILURE:
        case FavoriteTypes.SET_CATEGORY_FAVORITE_FAILURE:
        case FavoriteTypes.SET_PROGRAM_FAVORITE_FAILURE:
        case FavoriteTypes.REMOVE_COURSE_FAVORITE_FAILURE:
            return { ...state, loading: false, hasError: true };
        case FavoriteTypes.REMOVE_PROGRAM_FAVORITE_FAILURE:
            return { ...state, loading: false, hasError: true };
        case FavoriteTypes.BATCH_FAVORITE_REQUEST:
            return { ...state, loading: true };
        case FavoriteTypes.BATCH_FAVORITE_SUCCESS:
            return { ...state, loading: false, success: true, hasError: false };
        case FavoriteTypes.BATCH_FAVORITE_FAILURE:
            return { ...state, loading: false, hasError: true, success: false };
        case FavoriteTypes.BATCH_FAVORITE_CLEAR:
            return { ...state, loading: false, hasError: false, success: false };
        default:
            return state;
    }
};

export default reducer;
